import {
  NavigationDrawer as CXNavigationDrawer,
  INavigationDrawer as CXINavigationDrawer
} from '@sanlamcx/react-ui-next-navigation-drawer';

export const NavigationDrawer = CXNavigationDrawer;
export type INavigationDrawer = CXINavigationDrawer;
